import { z } from 'zod';
import { MyOrganization } from 'libs/end-to-end/src/my-organization';
import { OrganizationRoleAssignments } from 'libs/end-to-end/src/organization-role-assignments';

export const MyUser = z.object({
  id: z.string().min(1),
  email: z.string().min(1),
  organization: MyOrganization.nullable(),
  roleAssignments: OrganizationRoleAssignments,
});

export type MyUser = z.infer<typeof MyUser>;
